module.exports = __webpack_public_path__ + "img/hongyun-mobile.78df8849.gif";